<!-- Messenger Plugin chat Code -->
<template>
  <div
    v-if="settingData"
    class="col-md-12"
  >

    <!-- Messenger Plugin chat Code -->
    <div id="fb-root" />

    <!-- Your Plugin chat code -->
    <div
      id="fb-customer-chat"
      class="fb-customerchat"
      :page_id="settingData.app.fb_chat_enable == 1 ? settingData.app.fb_chat : ''"
      attribution="biz_inbox"
    />
  </div>
</template>
 <!-- page_id="104084762305706" -->
<!-- <script>
window.fbAsyncInit = function () {
  FB.init({
    xfbml: true,
    version: 'v17.0',
  });
};

(function (d, s, id) {
  let js; const
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
</script> -->
<script>
import {
  ref, computed, watch, onMounted,
} from '@vue/composition-api';
import store from '@/store';

export default {
  // computed: {
  //   settingData: {
  //     set() { },
  //     get() {
  //       console.log('l1', this.$store.state.app.settings)
  //       if (this.$store.state.app.settings) {
  //         this.renderFb()
  //       }
  //       console.log('l2', this.$store.state.app.settings)
  //       return this.$store.state.app.settings
  //     },

  //   },
  // },
  mounted() {

  },
  setup(props, context) {
    const renderFb = () => {
      window.fbAsyncInit = function () {
        FB.init({
          xfbml: true,
          version: 'v17.0',
        });
      };

      (function (d, s, id) {
        let js; const
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
    const settingData = computed({
      // getter
      get() {
        console.log('l1', store.state.app.settings)
        if (store.state.app.settings) {
          renderFb()
        }
        console.log('l2', store.state.app.settings)
        return store.state.app.settings
      },
      // setter
      set() {
      },
    })
    return {
      renderFb,
      settingData,
    }
  },
  methods: {

  },
}
</script>
<style lang="scss">
.fb_dialog_content {
  iframe {}
}
</style>
